import React, { useEffect, useRef } from "react";
import { array, bool, func, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";

import NavbarSearch from "../NavbarSearch";
import Navbar from "../Navbar";
import { Email, Facebook, Twitter } from "../../../atoms/icons/StoryPageIcons";
import WatsAppIcon from "../../../atoms/icons/WatsAppIcon";
import MessengerIcon from "../../../../../assets/images/messenger.svg";
import LauncherIcon from "../../../../../assets/images/launcher.svg";
import Youtube from "../../../layouts/footer/DefaultFooter/Youtube";
import Instagram from "../../../layouts/footer/KishoraloFooter/Instagram";
import { WhiteCloseIcon } from "../../../basic/icons/white-close-icon";
import Icon from "../../../icons";

import { getDateFromUtils } from "../../../utils/utils";

import "./verticalMenubar.m.css";

const VerticalMenubar = ({
  isDesktop,
  toggleVerticalMenubar,
  hamburgerMenu,
  socialLinks,
  lang,
  domainSlug,
  dot,
  customSocialLinks,
}) => {
  const socialShareLinks = customSocialLinks[domainSlug] || socialLinks;
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      toggleVerticalMenubar();
    }
  };

  useEffect(() => {
    if (isDesktop) {
      ref.current.classList.remove("preload");

      document.addEventListener("click", handleClickOutside, true);

      return () => {
        document.removeEventListener("click", handleClickOutside, true);
        toggleVerticalMenubar();
      };
    }
  });

  return (
    <div styleName="vertical-menubar-wrapper" className="vertical-menubar-wrapper">
      {isDesktop && (
        <div onClick={toggleVerticalMenubar} styleName="close" className="button-close">
          <WhiteCloseIcon width={30} height={30} />
        </div>
      )}

      <div ref={ref} className="vertical-menubar preload" styleName={`${lang}-menubar vertical-menubar slide-in`}>
        {!isDesktop && (
          <div styleName="vertical-menubar-header">
            <div styleName="date-notification-container">
              <time styleName="date">{getDateFromUtils(lang)}</time>
              {!domainSlug && (
                <Link
                  aria-label="notification page link"
                  href="notifications"
                  styleName={`bell-container ${dot ? "new-notifications-data" : "no-notifications"}`}
                  className="bell-container"
                >
                  <Icon type="bell" className="bell" />
                </Link>
              )}
            </div>
          </div>
        )}
        {!isDesktop && <NavbarSearch lang={lang} />}
        <div styleName="navbar-container">
          <Navbar
            menu={hamburgerMenu}
            domainSlug={domainSlug}
            verticalNavbar={true}
            toggleVerticalMenubar={toggleVerticalMenubar}
          />
          <div styleName="bottom-container">
            <div
              styleName={`social-share-icons ${
                Object.keys(socialShareLinks).length && Object.keys(socialShareLinks).length > 3
                  ? "justify-space-between"
                  : "justify-space-around"
              }`}
            >
              {socialShareLinks["facebook-url"] && (
                <Link
                  aria-label="Facebook Link"
                  href={socialShareLinks["facebook-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook color2="#1877f2" />
                </Link>
              )}
              {socialShareLinks["twitter-url"] && (
                <Link
                  aria-label="Twitter Link"
                  href={socialShareLinks["twitter-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Twitter color2="#1da1f2" />
                </Link>
              )}
              {socialShareLinks["messenger-url"] && (
                <Link
                  aria-label="Messenger Link"
                  href={socialShareLinks["messenger-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={`${assetify(MessengerIcon)}`} alt="messenger logo" styleName="messenger" />
                </Link>
              )}
              {socialShareLinks["telegram-url"] && (
                <Link
                  aria-label="Telegram Link"
                  href={socialShareLinks["telegram-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={`${assetify(LauncherIcon)}`} alt="launcher logo" styleName="launcher" />
                </Link>
              )}
              {socialShareLinks["whatsapp-url"] && (
                <Link
                  aria-label="Whatsapp Link"
                  href={socialShareLinks["whatsapp-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WatsAppIcon />
                </Link>
              )}
              {socialShareLinks["email-url"] && (
                <Link
                  aria-label="Email Link"
                  href={socialShareLinks["email-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Email />
                </Link>
              )}
              {socialShareLinks["youtube-url"] && (
                <Link
                  aria-label="Youtube Link"
                  href={socialShareLinks["youtube-url"]}
                  className="youtube-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Youtube color1="#ff0000" />
                </Link>
              )}
              {socialShareLinks["instagram-url"] && (
                <Link
                  aria-label="Instagram Link"
                  href={socialShareLinks["instagram-url"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram color1="#eee" color2="#c32aa3" />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

VerticalMenubar.propTypes = {
  isDesktop: bool,
  toggleVerticalMenubar: func,
  hamburgerMenu: array,
  domainSlug: string,
  lang: string,
  socialLinks: object,
  customSocialLinks: object,
  dot: bool,
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(VerticalMenubar);
